import { CommonModule } from "@angular/common";
import { ModuleWithProviders, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { StoreModule } from "@ngrx/store";
import { TranslateModule } from "@ngx-translate/core";

import { AuthModule } from "@intocare/auth";
import { AWSModule } from "@intocare/aws";
import { CoreModule as SharedCoreModule } from "@intocare/core";
import { LanguageModule, LanguagePipe } from "@intocare/language";
import { PipesModule } from "@intocare/pipes";
import { UIModule } from "@intocare/ui";
import { MyDatePickerModule } from "@intocare/ui-my-date-picker";
import { MyDateRangePickerModule } from "@intocare/ui-my-date-range-picker";

import { ChipsContainerComponent } from "./components/chips-container/chips-container.component";
import { FilePreviewComponent } from "./components/file-preview/file-preview.component";
import { FileSelectComponent } from "./components/file-select/file-select.component";
import { HomeComponent } from "./containers/home/home.component";
import {
	AuthenticatedGuard,
	ConfirmPasswordGuard,
	IsAuthenticatedGuard,
	NotAuthenticatedGuard,
	OrganisationGuard,
} from "./guards";
import { GlobalInfoModel } from "./models/global-info.model";
import { HomesModel } from "./models/home.model";
import { PharmaciesModel } from "./models/pharmacies.model";
import { reducers } from "./reducers";
import { WindowRef } from "./tokens/window-ref";

// Components

export function windowFactory() {
	return window;
}

@NgModule({
	imports: [
		StoreModule.forFeature("core", reducers),
		AuthModule,
		RouterModule,
		TranslateModule,
		CommonModule,
		HomeComponent,
		UIModule,
		AWSModule,
		MyDatePickerModule,
		FormsModule.withConfig({ callSetDisabledState: "whenDisabledForLegacyCode" }),
		MyDateRangePickerModule,
		LanguageModule,
		SharedCoreModule,
		PipesModule,
	],
	exports: [
		RouterModule,
		CommonModule,

		ReactiveFormsModule.withConfig({ callSetDisabledState: "whenDisabledForLegacyCode" }) as any,
		UIModule,
		AWSModule,
		TranslateModule,
		LanguagePipe,
		FileSelectComponent,
		FilePreviewComponent,
		PipesModule,
		ChipsContainerComponent,
	],
	declarations: [FileSelectComponent, FilePreviewComponent, ChipsContainerComponent],
})
export class CoreModule {
	static forRoot(): ModuleWithProviders<CoreModule> {
		return {
			ngModule: CoreModule,
			providers: [
				AuthenticatedGuard,
				NotAuthenticatedGuard,
				IsAuthenticatedGuard,
				ConfirmPasswordGuard,
				OrganisationGuard,
				GlobalInfoModel,
				HomesModel,
				PharmaciesModel,
				LanguagePipe,
				{ provide: WindowRef, useFactory: windowFactory },
			],
		};
	}
}
